












































import moment from 'moment-timezone'
import ProgressBar from '@/components/sub-components/ProgressBar.vue'
import ThreeDotMenu from '@/components/sub-components/ThreeDotMenu.vue'
import ConfirmDeleteActionDialog from '@/components/dialog/ConfirmDeleteActionDialog.vue'

export default {
  components: {
    ProgressBar,
    ThreeDotMenu,
    ConfirmDeleteActionDialog,
  },
  props: {
    exerciseProgram: {
      type: Object,
      required: true,
    },
    lastExerciseSessionDate: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      showDeleteExerciseProgramDialog: false,
    }
  },
  computed: {
    programOptions() {
      return [
        {
          label: 'Edit',
          icon: 'mdi-pencil-outline',
          color: 'primary',
          action: this.editExerciseProgram,
        },
        {
          label: 'Delete',
          icon: 'mdi-trash-can-outline',
          color: 'red',
          action: this.openDeleteExerciseProgramDialog,
        },
      ]
    },
    percentProgramTimeElapsed() {
      const unixStart = moment(this.exerciseProgram.startDate).unix()
      const percentElapsed = Math.floor(
        ((moment().unix() - unixStart) / (moment(this.exerciseProgram.endDate).unix() - unixStart)) * 100
      )
      return percentElapsed > 100 ? 100 : percentElapsed
    },
    lastSessionDate() {
      if (this.lastExerciseSessionDate) {
        return this.formatProgramDates(this.lastExerciseSessionDate)
      } else {
        return false
      }
    },
  },
  methods: {
    formatProgramDates(date: string): string {
      if (date) {
        return moment(date).format('DD MMMM YYYY')
      } else {
        return '-'
      }
    },
    editExerciseProgram() {
      this.$emit('editExerciseProgramAction', this.exerciseProgram.id)
    },
    closeDeleteExerciseProgramDialog() {
      this.showDeleteExerciseProgramDialog = false
    },
    openDeleteExerciseProgramDialog() {
      this.showDeleteExerciseProgramDialog = true
    },
    confirmDeleteExerciseProgram() {
      this.closeDeleteExerciseProgramDialog()
      this.$emit('deleteExerciseProgramAction', this.exerciseProgram.id)
    },
  },
}
